import { useEffect, useState } from "react";
import Button from "../../../components/Button";
import Datepicker from "../../../components/Datepicker";
import { useDispatch, useSelector } from "react-redux";
import { fetchToursThunk } from "../../../lib/service/tours/toursSlice";
import { fetchCategoriesThunk } from "../../../lib/service/categories/categoriesSlice";
import { fetchToursDatesThunk } from "../../../lib/service/tours/toursAvailableDatesSlice";
import { fetchToursDetailsThunk } from "../../../lib/service/tours/toursDetailsSlice";
import Cookies from "js-cookie";
import { useTransformedData } from "../../../contexts/TransformedDataContext";
import { useAuth } from "../../../contexts/AuthContext";

function TourSearch() {
  const [date, setDate] = useState("");
  const [allowedDates, setAllowedDates] = useState([]); // Allowed dates array
  const { transformedData, setTransformedData } = useTransformedData();
  const { loggedIn, logout } = useAuth();

  const dispatch = useDispatch();
  const {
    details,
    loading: detailsLoading,
    error: detailsError,
  } = useSelector((state) => state.toursDetails);
  const {
    categories,
    loading: categoriesLoading,
    error: categoriesError,
  } = useSelector((state) => state.categories);

  const { tours, loading, error } = useSelector((state) => state.tours);

  const handleDatepickerFocus = () => {
    if (allowedDates.length === 0) {
      // Fetch allowed dates from the API
      dispatch(fetchToursDatesThunk({ all: 1, logout }))
        .unwrap()
        .then((response) => {
          if (response?.data) {
            // Convert allowed dates to Date objects
            const parsedDates = response.data?.map((date) => new Date(date));
            setAllowedDates(parsedDates);
          }
        })
        .catch((error) => {
          console.error("Error fetching tours:", error);
        });
    }
  };

  const handleFindTour = async (newDate) => {
    // console.log(newDate)
    const dateCondition = newDate || date;
    // console.log(date)
    if (dateCondition) {
      try {
        // Format date to YYYY-MM-DD without timezone effects
        const formattedDate = `${dateCondition.getFullYear()}-${String(dateCondition.getMonth() + 1).padStart(2, "0")}-${String(dateCondition.getDate()).padStart(2, "0")}`;

        // Wait for fetchToursThunk to complete
        const toursResponse = await dispatch(
          fetchToursThunk({
            date: formattedDate,
            logout,
          })
        ).unwrap();

        const serviceIds = toursResponse?.data
          ?.flatMap((tour) => tour?.items)
          ?.map((item) => item?.service_id);

        const hasProductIds = serviceIds.join(",");

        const categoriesResponse = await dispatch(
          fetchCategoriesThunk({ has_product_ids: hasProductIds })
        ).unwrap();

        const toursDetailsResponse = await dispatch(
          fetchToursDetailsThunk({ products_id: hasProductIds })
        ).unwrap();
      } catch (error) {
        console.error("Error during data fetching:", error);
      }
    }
  };

  useEffect(() => {
    if (categories?.data) {
      const transformed = categories?.data?.map((category) => {
        const matchingTours = tours?.data[0]?.items?.filter(
          (tour) => String(tour?.category_id) === String(category?.id)
        );
        const customerID = Cookies.get("customerId");
        const eventIds = tours?.data?.flatMap((tour) =>
          tour?.items?.map((item) => item?.event_id)
        );

        return {
          id: category?.id,
          group: category.title,
          tours: matchingTours?.map((tour) => ({
            tour: details?.data?.find((x) => x?.id == tour?.service_id)?.name,
            time: `${tour?.start_time.slice(0, 5)} to ${tour?.end_time.slice(0, 5)}`,
            startTime: tour?.start_time,
            endTime: tour?.end_time,
            tourId: tour?.service_id,
            eventItemId: tour?.id,
            eventId: eventIds,
            customerId: customerID,
            date: tour?.start.split(" ")[0],
            categoryId: category?.id,
          })),
        };
      });

      setTransformedData(transformed);
    }
  }, [categories]);

  useEffect(() => {
    if (tours?.data?.[0]?.items?.[0]?.start) getDate(tours);
  }, [tours]);

  const getDate = (tours) => {
    const date = new Date(tours.data?.[0].items?.[0].start.split(" ")[0]);
    setDate(date);
  };

  // console.log("date", date);

  // useEffect(() => {
  //   if (date) handleFindTour();
  // }, [date]);

  return (
    <div>
      <div className="leap-flex-col md:leap-flex-row leap-flex leap-gap-4 leap-justify-center leap-px-2">
        <div
          className="!leap-rounded-[16px] leap-py-[1px] leap-w-fit leap-mx-auto md:leap-mx-0 leap-px-[1.1px]"
          style={{
            background:
              "linear-gradient(180deg, #EB3DF7 0%, #3B29AB 50%, #73FAFD 100%)",
          }}
        >
          <Datepicker
            selectedDate={date}
            onChange={(date) => {
              setDate(date);
              handleFindTour(date);
            }}
            onFocus={handleDatepickerFocus}
            allowedDates={allowedDates}
            className="leap-mx-auto"
          />
        </div>
        <div className="leap-flex leap-justify-center">
          <Button
            text="Find Tour"
            bgColor={date ? "#73FAFD" : "#A9A9A9"}
            textColor={date ? "black" : "white"}
            customStyles="leap-uppercase"
            onClick={() => handleFindTour()}
            disabled={!date}
          />
        </div>
      </div>
    </div>
  );
}

export default TourSearch;
